import { PrintJob } from '../api/types/vendor/carts-types';

/**
 * Opens the cash drawer by sending a message to the webview.
 */
const open = (printJobs: PrintJob[]): void => {
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({
      type: 'cash_drawer',
      payload: { action: 'open', printJobs },
    }),
  );
};

export default {
  open,
};
